export interface PhoneAliasesEditable {
  id: string;
  phone?: string | null;
  phone_aliases?: (string | null)[] | null | undefined;
}

export const normalizePhoneAliases = (
  aliases: (string | null)[] | null | undefined
): string[] => {
  if (!aliases) return [];
  return aliases.filter((alias): alias is string => alias != null && alias.trim().length > 0);
};
